export const faqs = [
  {
    q: 'How Will I Receive the Material?',
    a: [
      "After your payment is confirmed, you'll receive instructions for accessing your digital purchase.",
      'The six volumes and five bonuses will be provided in the formats specified at checkout.',
    ],
  },
  {
    q: 'Who Is This Collection For?',
    a: [
      'The collection is intended primarily for physiotherapists, physical therapists, and rehabilitation professionals who want to organize their learning and review the assessment of low back pain.',
      'Students may also find the educational frameworks and case scenarios useful as supplementary learning resources.',
    ],
  },
  {
    q: 'Is This Suitable for Practicing Physiotherapists?',
    a: [
      'Yes. The material is designed as an educational reference that professionals can use to review assessment concepts, organize documentation, and practice clinical reasoning.',
      'It does not replace continuing professional education, current clinical guidelines, or individualized clinical judgment.',
    ],
  },
  {
    q: 'Is This Suitable for Students?',
    a: [
      'Yes. Students can use the collection to review relevant concepts, organize their study, and practice interpreting hypothetical clinical cases.',
      'The educational cases should not be treated as substitutes for supervised clinical training.',
    ],
  },
  {
    q: 'Does This Teach Me How to Diagnose Every Cause of Low Back Pain?',
    a: [
      'No. The collection is designed to support the organization of assessment information and clinical reasoning.',
      'It does not guarantee diagnostic accuracy or provide a definitive diagnostic protocol for every presentation.',
    ],
  },
  {
    q: 'Does It Include Red Flags?',
    a: [
      'Yes. One of the volumes focuses on organizing potentially concerning findings, screening considerations, and general principles for further evaluation or referral.',
      'This material does not replace emergency procedures, local referral protocols, or appropriate medical assessment.',
    ],
  },
  {
    q: 'Can I Use the Material With Patients?',
    a: [
      'The resources are intended to support professional learning and the organization of assessment concepts.',
      "Any application in clinical practice must be guided by your qualifications, professional scope, the patient's individual presentation, applicable regulations, and current clinical guidance.",
    ],
  },
  {
    q: 'Do I Need Special Software?',
    a: ['You should not need specialized clinical software to study the content. The exact file formats are confirmed in the product delivery details.'],
  },
  {
    q: 'Is This a Subscription?',
    a: ['No. The advertised offer is a one-time payment of $27, with no recurring subscription.'],
  },
  {
    q: 'Will I Have Lifetime Access?',
    a: ['The offer provides lifetime access to the purchased files, subject to the terms disclosed at checkout.'],
  },
  {
    q: "What If I'm Not Satisfied?",
    a: ['Your purchase is covered by a seven-day money-back guarantee. You can request a refund within the stated period in accordance with the published terms.'],
  },
];
